import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCircularLoading = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 16 16'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <mask
      id='circular_loading_svg__a'
      width={8}
      height={16}
      x={8}
      y={0}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path stroke='#000' strokeWidth={4} d='M8 2a6 6 0 1 1 0 12' />
    </mask>
    <g mask='url(#circular_loading_svg__a)'>
      <path fill={props.fill} d='M8 16A8 8 0 1 0 8 0v16' />
    </g>
    <mask
      id='circular_loading_svg__b'
      width={8}
      height={16}
      x={0}
      y={0}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path stroke='#000' strokeWidth={4} d='M8 14A6 6 0 0 1 8 2' />
    </mask>
    <g mask='url(#circular_loading_svg__b)'>
      <path fill={props.fill} d='M7.86.001A8 8 0 0 0 8.14 16L8 8z' />
    </g>
  </svg>
)
const ForwardRef = forwardRef(SvgCircularLoading)
export default ForwardRef

